import { render, staticRenderFns } from "./buyShebei.vue?vue&type=template&id=3ce641d2&scoped=true&"
import script from "./buyShebei.vue?vue&type=script&lang=js&"
export * from "./buyShebei.vue?vue&type=script&lang=js&"
import style0 from "./buyShebei.vue?vue&type=style&index=0&id=3ce641d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce641d2",
  null
  
)

export default component.exports